<template>
	<tr class="lh-sm align-top">
		<td class="text-sm">
			<div class="hstack gap-2 align-items-start flex-fill">
				<CommonImageSquare :src="product.image_url" size="md" rounded="3" :border="true" class="mx-auto" />
				<div class="vstack">
					<div class="fw-bold">{{ product.name }}</div>
					<div class="hstack gap-2 justify-content-between">
						<div class="vstack">
							<div class="fw-bold text-muted">{{ vueNumberFormat(product.amount, { suffix: ` ${product.currency}`, precision: 2 }) }}</div>
							<small class="text-muted" v-if="product.extras?.code"><b>Código:</b> {{ product.extras.code }}</small>
							<small class="text-muted" v-if="product.pivot?.attributes?.color"><b>Color:</b> {{ product.pivot.attributes.color }}</small>
							<small class="text-muted" v-if="product.pivot?.attributes?.size"><b>Medida:</b> {{ product.pivot.attributes.size }}</small>
						</div>
						<div class="input-group input-group-sm rounded-pill mt-1" style="width: 110px;">
							<button class="btn btn-dark rounded-start-pill ps-3 pe-2" type="button" v-if="product.pivot.quantity == 1" @click="remove">
								<i class="bi bi-trash"></i>
							</button>
							<button class="btn btn-dark rounded-start-pill ps-3 pe-2" type="button" v-else-if="product.pivot.quantity > 1" @click="decrease">
								<i class="bi bi-dash-lg"></i>
							</button>
							<input type="text" v-model="product.pivot.quantity" class="form-control text-center px-1" disabled>
							<button class="btn btn-dark rounded-end-pill ps-2 pe-3" type="button" :disabled="product.pivot.quantity >= product.pivot.stock" @click="increase">
								<i class="bi bi-plus-lg"></i>
							</button>
						</div>
					</div>
				</div>
			</div>
		</td>
	</tr>
</template>

<script>
	export default {
		emits: ['increase', 'decrease', 'remove'],
		props: {
			index: Number,
			product: Object
		},
		setup(props, { emit }) {
			const increase = () => emit('increase', props.index);
			const decrease = () => emit('decrease', props.index);
			const remove = () => emit('remove', props.index);

			return { increase, decrease, remove };
		}
	}
</script>